import React from 'react';
import { usePartnersStrings } from '../usePartnersStrings';

const PartnersStatsBar: React.FC = () => {
  const s = usePartnersStrings();

  return (
    <section className="container-chisme pb-10 lg:pb-16">
      <div className="relative overflow-hidden rounded-[36px] bg-[#2a0f2a] px-6 py-10 sm:px-10 sm:py-12 lg:px-16 lg:py-14">
        <div
          className="pointer-events-none absolute -right-24 -top-32 size-[460px] rounded-full opacity-90"
          style={{
            background:
              'radial-gradient(circle at center, rgba(235,66,178,0.55) 0%, rgba(235,66,178,0) 70%)',
          }}
          aria-hidden
        />
        <div className="relative grid grid-cols-1 gap-8 sm:grid-cols-3 sm:gap-6">
          {s.stats.map((stat) => (
            <div key={stat.label} className="text-center sm:text-left">
              <p className="font-instrument text-4xl italic tracking-[-0.01em] text-[#ff99d5] sm:text-5xl">
                {stat.value}
              </p>
              <p className="mt-1 font-jakarta text-sm font-semibold text-white sm:text-base">{stat.label}</p>
              {stat.sub && (
                <p className="mt-0.5 font-jakarta text-xs text-white/50">{stat.sub}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersStatsBar;
